import React, { useState } from "react";
import { Box, Button, Grid, TextField, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { checkDomainName } from "../../../redux/actions/organizationProfileCreators";
import validator from "validator";

export default function InputField({
  data,
  addQuestion,
  deleteQuestionsAfterIndex,
  goToNextQuestion,
  isVisible,
  addToUpdateQuestions,
  deleteFromQuestionToUpdate,
}) {
  // constants
  //   const isMobile = useMediaQuery("(max-width:768px)");
  const { t } = useTranslation();
  const language = localStorage.getItem("i18nextLng");

  // state to manage input field value
  const [value, setValue] = useState(data?.currentValue || "");
  const [error, setError] = useState(false);
  const [helperText, setHelperText] = useState("");
  // handler for input value change
  const handleInputChange = (event) => {
    setError(false);
    setHelperText("");
    deleteQuestionsAfterIndex(data);
    deleteFromQuestionToUpdate(data);
    setValue(event.target.value);
  };

  // handler for "Next" button click
  const handleNextClick = async () => {
    if (data.key === "name_A" && value !== data.currentValue) {
      if (validator.isFQDN(value, { require_tld: true })) {
        const { valid, message } = await checkDomainName(value);
        if (valid === true) {
          if (data && value && value !== data.currentValue) {
            addToUpdateQuestions(data, value);
          }
          if (data?.question_object) {
            addQuestion(data?.question_object);
          } else {
            // Otherwise, move to the next question
            goToNextQuestion();
          }
        } else {
          setError(true);
          setHelperText(message);
        }
      } else {
        setError(true);
        const message =
          language === "fr"
            ? "Nom de domaine non valide. Veuillez saisir un domaine valide."
            : "Invalid domain name. Please enter a valid domain.";
        setHelperText(message);
      }
    } else {
      if (data && value && value !== data.currentValue) {
        addToUpdateQuestions(data, value);
      }
      if (data?.question_object) {
        addQuestion(data?.question_object);
      } else {
        // Otherwise, move to the next question
        goToNextQuestion();
      }
    }
  };

  function handleSkipClick() {
    if (data?.associated_step_id === "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b") {
      if (data?.question_object) {
        addQuestion(data?.question_object);
      } else {
        // Otherwise, move to the next question
        goToNextQuestion(null, true);
      }
    } else {
      goToNextQuestion(null, true);
    }
  }

  // return
  return (
    <Box
      style={{
        padding: "20px",
        width: "auto",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
      }}
    >
      {/* Question */}
      <Typography variant="subtitle1" sx={{ mb: 2 }}>
        {language === "fr" ? data?.question_fr : data.question}
      </Typography>

      {/* Input Field */}
      <Grid container sx={{ marginBottom: "20px" }}>
        <TextField
          id="outlined-basic"
          placeholder={
            language === "fr" ? "Entrez une valeur" : "Enter a Value"
          }
          value={value}
          onChange={handleInputChange} // onChange function to handle updates
          variant="outlined"
          multiline={data.multiline}
          rows={data.multiline ? 3 : 1}
          error={error}
          helperText={error ? helperText : null}
          fullWidth
        />
      </Grid>

      <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
        {isVisible(data) && (
          <Button
            variant="contained"
            color="secondary"
            style={{
              height: "50px",
              width:
                data?.associated_step_id !==
                "4c2ea3bd-831a-4a53-8cc7-5ec1b26d628b"
                  ? "50%"
                  : "50%", // Each button takes 45% of the container width
              marginTop: "20px",
            }}
            onClick={handleNextClick}
            disabled={!value} // Disable if required fields are empty
          >
            {data?.last_step_question_2 ? t("finish") : t("next")}
          </Button>
        )}
        {isVisible(data) && (
          <Button
            style={{
              height: "50px",
              width: "50%", // Each button takes 45% of the container width
              marginTop: "20px",
            }}
            color="secondary"
            variant="contained"
            onClick={handleSkipClick}
          >
            {t("skip")}
          </Button>
        )}
      </div>
    </Box>
  );
}
